import React, { PropTypes } from 'react';

import Social from 'components/Social';
import BioImage from 'img/kiandra.jpg';

const Bio = (props) => {
    return (
        <div className="bio">
          <div className="bio-image">
            <img src={BioImage} alt="Dr. Kiandra Hebert" className="hero-image"/>
          </div>
          <h4>Learn to become more effective in your life</h4>
          <Social />
        </div>
    );
};

export default Bio;



/** WEBPACK FOOTER **
 ** ./src/components/LandingPage/Hero/Bio.js
 **/